import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { ProductsProvider } from './context/ProductsContext';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import ExitIntentPopup from './components/ExitIntentPopup';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './analytics/AnalyticsTracker';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Lavapavimenti from './pages/Lavapavimenti';
import Sgrassatori from './pages/Sgrassatori';
import Bundle from './pages/Bundle';
import ProductPage from './pages/ProductPage';
import ComeSiUsa from './pages/ComeSiUsa';
import ChiSiamo from './pages/ChiSiamo';
import FAQ from './pages/FAQ';
import Contatti from './pages/Contatti';
import Tracking from './pages/Tracking';
import Account from './pages/Account';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import InformativeGenerali from './pages/InformativeGenerali';
import './App.css';

// Admin panel — lazy-loaded in a separate chunk (NOT downloaded by public visitors)
const AdminApp = lazy(() => import('./admin/AdminApp'));

function Layout({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
      <CartDrawer />
      <ExitIntentPopup />
      <Toaster position="bottom-right" theme="light" richColors />
    </>
  );
}

function PublicSite() {
  return (
    <SiteSettingsProvider>
      <AuthProvider>
        <ProductsProvider>
          <CartProvider>
            <ScrollToTop />
            <AnalyticsTracker />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/lavapavimenti" element={<Lavapavimenti />} />
                <Route path="/sgrassatori" element={<Sgrassatori />} />
                <Route path="/bundle" element={<Bundle />} />
                <Route path="/prodotto/:slug" element={<ProductPage />} />
                <Route path="/come-si-usa" element={<ComeSiUsa />} />
                <Route path="/chi-siamo" element={<ChiSiamo />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contatti" element={<Contatti />} />
                <Route path="/tracking" element={<Tracking />} />
                <Route path="/account" element={<Account />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/informative-generali" element={<InformativeGenerali />} />
              </Routes>
            </Layout>
          </CartProvider>
        </ProductsProvider>
      </AuthProvider>
    </SiteSettingsProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#020617', color: '#94a3b8' }}>Caricamento pannello…</div>}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route path="/*" element={<PublicSite />} />
      </Routes>
    </BrowserRouter>
  );
}
